import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import useViewport from '../../../common/hooks/useViewport'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { CreateEditProfile } from '../createEditProfile'
import classes from './index.module.scss'

export const CreateProfile = () => {
  const { width, height } = useViewport()
  const userType = useSelector(selectUserType)
  const isStandardUser = userType?.userTypeId === USER_TYPE.STANDARD

  const [isShow, setIsShow] = useState(false)

  const handleClick = () => {
    if (isStandardUser) return
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  return (
    <>
      <Element className={classes.createProfile}>
        <Element
          className={classes.createBtn}
          style={{
            color: isStandardUser ? '#9C9C9C' : '#FFFFFF',
            backgroundColor: isStandardUser ? '#D5D5D5' : '#2C73E8',
            cursor: isStandardUser ? 'not-allowed' : 'pointer',
          }}
          onClick={handleClick}
        >
          <Icon className="icon-plus" style={{ fontSize: 7 }} />
          <Element>
            <Translate value="alertSetting.CREATE_ALERT_PROFILE" />
          </Element>
        </Element>
        {isStandardUser && (
          <Element style={{ marginTop: 4 }}>
            <Element elementName="span" style={{ color: '#2C73E8' }}>
              <Link to="">
                <Translate value="alertSetting.UPGRADE" />
              </Link>
            </Element>
            <Translate value="alertSetting.UPGRADE_ACCOUNT_TO_CREATE_PROFILE" />
          </Element>
        )}
      </Element>
      <PopupAction
        isShow={isShow}
        title="alertSetting.NEW_ALERT_PROFILE"
        handleClose={handleClose}
        appendStyle={{
          width: 0.95 * width,
          maxWidth: 1000,
          padding: '20px 20px 8px 20px',
          backgroundColor: '#F3F3F3',
          borderRadius: '4px',
        }}
      >
        <Element
          style={{ height: 0.8 * height, maxHeight: 884, margin: '0 -8px' }}
        >
          <CreateEditProfile
            createMode={true}
            onCancel={handleClose}
            onSave={handleClose}
          />
        </Element>
      </PopupAction>
    </>
  )
}
